export default __webpack_public_path__ + "alberta-help.cc3512a9f0dffa4ddb38.svg";